import { ImArrowDown2 } from "@react-icons/all-files/im/ImArrowDown2";
import Img from "components/atoms/Img";
import FaqsGroup from "components/molecules/FaqsGroup";
/*** Vendors ***/

/*** components ***/

/*** ========== ***/
/**
 *
 * @param {{
 * imgPosition: "left"|"right";
 * }} props Props for the component
 *
 */
const ImageDescribe = ({ properties }) => {
  const { img_src, img_height, img_position, width, height } = properties;
  return (
    <div
      className={`mt-8 lg:col-5 lg:mt-0 ${img_position === "left" ? "lg:order-first" : "lg:order-last"
        }`}
    >
      <Img
        src={img_src}
        width={width || 445}
        height={height || 624}
        className="h-full w-full rounded object-cover object-center"
        wrapper={{
          className: `w-full flex items-center justify-center ${img_height || "h-auto"
            }`,
        }}
      />
    </div>
  );
};
const AccordionImg = ({ data }) => {
  return (
    <div {...data.wrapper}>
      <div className="row">
        <div className=" lg:col-7 lg:-mt-4">
          <div {...data.content_wrapper}>
            <FaqsGroup
              data={data.info_list}
              {...(typeof data.active != "undefined"
                ? { defaultActiveKey: data.active }
                : 0)}
              icon={{
                Icon: ImArrowDown2,
                size: 20,
                className: "p-1 text-gleads-oxfordBlue-700",
                wrapperSubclass: "shadow rounded-full  bg-white",
              }}
              accordionClass={
                data?.border || "border-b border-b-gleads-oxfordBlue-800 mb-0"
              }
              buttonClass={
                data?.button_class ||
                "px-0 py-3 lg:py-4 pr-20 font-semibold text-xl"
              }
              buttonWrapperClass={{
                open: "bg-transparent",
                close: "bg-transparent",
              }}
              buttonContentClass={{
                open:
                  (data.text_color_open && data.text_color_open) ||
                  "text-gleads-oxfordBlue-800 ",
                close:
                  (data.text_color && data.text_color + ` opacity-80`) ||
                  "text-gleads-oxfordBlue-800 opacity-80",
              }}
              panelClass={data.panel_class}
            />
          </div>
        </div>
        <ImageDescribe properties={data.img_props} />
      </div>
    </div>
  );
};

export default AccordionImg;
